import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Panel} from 'react-bootstrap';
import {Button, IconButton} from '@material-ui/core';
import {Edit as EditIcon, DeleteForever as DeleteForeverIcon} from '@material-ui/icons';
import {CommonModal, DeletionConfirmBox} from 'components/common';
import {SecondaryNavigation} from 'components/Navigation';
import AwardUpdate from './AwardUpdate';
import {deleteAward} from 'api';
import {fetchAward} from 'actions/awards';
import {addFlashMessage} from 'actions/flash-message';
import {formatErrors} from 'actions/errors';
import {levelMap} from 'utils/common';
import * as permissions from 'utils/permissions';

class AwardDetail extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };
  static propTypes = {
    award: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      updateModalShown: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.deleteAward = this.deleteAward.bind(this);
  }

  componentDidMount() {
    const {
      fetchAward,
      formatErrors,
      match: {
        params: {awardId},
      },
    } = this.props;
    fetchAward(awardId).catch((err) => formatErrors(err, '/awards'));
  }

  showModal() {
    this.setState({
      updateModalShown: true,
    });
  }

  closeModal() {
    this.setState({
      updateModalShown: false,
    });
  }

  deleteAward() {
    const {
      addFlashMessage,
      formatErrors,
      match: {
        params: {awardId},
      },
    } = this.props;
    deleteAward(awardId)
      .then(() => {
        addFlashMessage('The award has been successfully deleted!', 'success');
        this.context.router.history.push('/awards');
      })
      .catch((err) => formatErrors(err));
  }

  render() {
    const {updateModalShown} = this.state;
    const {award, role} = this.props;
    return [
      <SecondaryNavigation key="secondary-nav" hasBack />,
      <div key="container" className="container content-box">
        <Panel>
          {permissions.isKluwellAdmin(role) && (
            <CommonModal title="Edit Award" onClose={this.closeModal} show={updateModalShown}>
              <AwardUpdate award={award} onSubmitSuccess={this.closeModal} />
            </CommonModal>
          )}
          <h3 className="section-header">
            <div className="section-title">Award Information</div>
            {permissions.isKluwellAdmin(role) && (
              <div>
                <DeletionConfirmBox
                  itemName="award"
                  deleteAction={this.deleteAward}
                  DeleteButton={(props) => (
                    <IconButton variant="contained" color="primary" {...props}>
                      <DeleteForeverIcon />
                    </IconButton>
                  )}
                />
                <IconButton variant="contained" color="primary" onClick={this.showModal}>
                  <EditIcon />
                </IconButton>
              </div>
            )}
          </h3>
          <div className="table-block">
            <div className="table-row">
              <div className="table-cell">Title</div>
              <div className="table-cell">{award.title}</div>
            </div>
            <div className="table-row">
              <div className="table-cell">Points</div>
              <div className="table-cell">{award.points}</div>
            </div>
            <div className="table-row">
              <div className="table-cell">Level</div>
              <div className="table-cell">{levelMap[award.level]}</div>
            </div>
            <div className="table-row">
              <div className="table-cell">Image</div>
              <div className="table-cell">
                {award.image && (
                  <img
                    src={award.image.startsWith('/') ? `${process.env.SERVER_BASE_URL}${award.image}` : award.image}
                  />
                )}
              </div>
            </div>
          </div>
        </Panel>
      </div>,
    ];
  }
}

export default connect(
  (state) => {
    const {awards, account} = state;
    return {
      role: account.getIn(['user', 'role']),
      award: awards.get('currentAward').toJS(),
    };
  },
  {
    addFlashMessage,
    formatErrors,
    fetchAward,
  },
)(AwardDetail);
